// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { assignShipToAddressModalStyles } from "@guestsupply/Overrides/Widgets/UserSetup/AssignShipToAddressModal";
import { xScreen } from "@guestsupply/XDL/Utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

assignShipToAddressModalStyles.buttonsWrapper = {
    css: css`
        margin-top: 30px;
        display: flex;
        gap: 10px;
        justify-content: end;
        ${xScreen("lt", "xs")} {
            flex-direction: column-reverse;
        }
    `,
};

assignShipToAddressModalStyles.cancelButton = {
    variant: "secondary",
    css: css`
        ${xScreen("lt", "xs")} {
            width: 100%;
        }
    `,
};

assignShipToAddressModalStyles.saveButton = {
    css: css`
        ${xScreen("lt", "xs")} {
            width: 100%;
        }
    `,
};

assignShipToAddressModalStyles.modal = { sizeVariant: "large" };
assignShipToAddressModalStyles.shipToContainer = {
    gap: 20,
    css: css`
        border-bottom: 1px solid ${getColor("common.border")};
        padding: 1rem 0;
    `,
};
assignShipToAddressModalStyles.shipToNumberGridItem = {
    width: [4, 2, 2, 2, 2],
    css: css`
        flex-direction: column;
    `,
};
assignShipToAddressModalStyles.shipToNumberLabel = {
    css: css`
        margin-bottom: 5px;
        font-size: 15px;
        font-weight: 600;
    `,
};
assignShipToAddressModalStyles.addressInfoGridItem = {
    width: [8, 6, 6, 6, 7],
    css: css`
        flex-direction: column;
    `,
};
assignShipToAddressModalStyles.centeringWrapper = {
    css: css`
        margin: auto;
    `,
};
assignShipToAddressModalStyles.assignShippingAddressGridItem = { width: [12, 4, 4, 4, 3] };
